import $ from 'jquery'
import { algoliasearch } from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import {
  connectInfiniteHits,
  connectStats,
} from 'instantsearch.js/es/connectors'
import infiniteHits from '../components/infiniteHits'
import {
  menu,
  sortBy,
  configure,
  hierarchicalMenu,
  clearRefinements,
  refinementList,
} from 'instantsearch.js/es/widgets'
import { history } from 'instantsearch.js/es/lib/routers'
import {
  connectSearchBox,
  connectCurrentRefinements,
} from 'instantsearch.js/es/connectors'
import { connectHits } from 'instantsearch.js/es/connectors'
import { algoliaAppId, algoliaApiKey, productSearchIndex } from '../variables'
import { productHit, noResult, productsButton } from '../templates'
import { dynamicUriTemplate, extractParamsFromUri } from '../functions'
import { lockBody, unlockBody } from '../utils'

// eslint-disable-next-line no-undef
const { __, _n, sprintf } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const { productsMainSlug, query, productCat } = object.algoliaQueryStrings

const slugs = {
  query,
  productCat,
}

let productsSearch
const checkEl = document.querySelector('.pt-products__hits')
if (checkEl) {
  const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)

  productsSearch = instantsearch({
    indexName: productSearchIndex,
    searchClient,
    insights: true,
    clickAnalytics: true,
    routing: {
      // Rewrite and create slugs with our options
      router: history({
        cleanUrlOnDispose: false,
        createURL({ location, routeState }) {
          const params = {
            query: routeState.query,
            productCat: routeState.productCat,
          }

          return dynamicUriTemplate(
            location.origin,
            params,
            productsMainSlug,
            slugs
          )
        },

        parseURL({ location }) {
          const params = extractParamsFromUri(location.href, slugs)

          return {
            query: params[slugs.query] && params[slugs.query][0],
            productCat: params[slugs.productCat],
          }
        },
      }),

      // Rewrite and create slugs with our options
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[productSearchIndex] || {}

          const res = {
            query: indexUiState.query,
            productCat:
              indexUiState.hierarchicalMenu?.['productCatHierarchical.lvl0'],
          }

          return res
        },

        routeToState(routeState) {
          return {
            [productSearchIndex]: {
              query: routeState.query,
              location_filter: routeState.location_filter,
              hierarchicalMenu: {
                'productCatHierarchical.lvl0': routeState.productCat,
              },
            },
          }
        },
      },
    },
  })

  const productItem = ({ hits, sendEvent, widgetParams }) => {
    const container = document.querySelector(widgetParams.container)

    container.innerHTML = `
      ${
        hits.length
          ? hits
              .map((item) => {
                return productHit(item, 'g-col-12 g-col-md-6 g-col-lg-4')
              })
              .join('')
          : noResult
      }
  `

    container
      .querySelectorAll('.feed-product__wrapper')
      .forEach((element, index) => {
        element.addEventListener('click', (event) => {
          sendEvent('click', hits[index], 'Product Clicked')
        })
      })
  }

  const productItems = connectHits(productItem)

  const renderSearchBox = (renderOptions, isFirstRender) => {
    const { query, refine, clear, isSearchStalled, widgetParams } =
      renderOptions
    const container = document.querySelector(widgetParams.container)

    if (isFirstRender) {
      const input = document.createElement('input')
      input.type = 'search'
      input.placeholder = widgetParams.placeholder

      container.insertAdjacentHTML('beforeend', object.loader)

      const reset = document.createElement('button')
      reset.type = 'reset'
      reset.insertAdjacentHTML('beforeend', '<i class="vn-icons-close"></i>')

      const submit = document.createElement('button')
      submit.type = 'submit'
      submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>')

      input.addEventListener('input', (product) => {
        refine(product.target.value)
      })

      reset.addEventListener('click', () => {
        clear()
      })

      container.appendChild(input)
      container.appendChild(reset)
      container.appendChild(submit)
    }

    container.querySelector('input').value = query
    container.querySelector('.vn-loader').hidden = !isSearchStalled
    container.querySelector('button[type="reset"]').hidden =
      isSearchStalled || !query
    container.querySelector('button[type="submit"]').hidden = isSearchStalled
  }

  const customSearchBox = connectSearchBox(renderSearchBox)
  const customInfiniteHits = connectInfiniteHits(
    infiniteHits(productHit, productsButton)
  )

  const renderStats = (renderOptions, isFirstRender) => {
    const { nbHits } = renderOptions

    // Récupérer les filtres appliqués via l'instance helper
    let numberOfFilters = 0
    if (renderOptions.instantSearchInstance.helper) {
      const appliedFiltersFacets =
        renderOptions.instantSearchInstance.helper.state
          .disjunctiveFacetsRefinements

      // Parcours des facettes et comptage des valeurs sélectionnées pour chaque facette
      for (const facet in appliedFiltersFacets) {
        if (appliedFiltersFacets.hasOwnProperty(facet)) {
          numberOfFilters += appliedFiltersFacets[facet].length
        }
      }

      // Récupérer et compter les filtres des hierarchical facets
      const hierarchicalFacetsRefinements =
        renderOptions.instantSearchInstance.helper.state
          .hierarchicalFacetsRefinements
      for (const facet in hierarchicalFacetsRefinements) {
        if (hierarchicalFacetsRefinements.hasOwnProperty(facet)) {
          // Compter le nombre de niveaux ou de valeurs sélectionnées pour chaque facette hiérarchique
          numberOfFilters += hierarchicalFacetsRefinements[facet].length
        }
      }
    }

    $('.js-sortby').append('<i class="vn-icons-arrow_circle_down"></i>')

    document.querySelectorAll('.js-products-stat').forEach((element) => {
      element.innerHTML = `
        <p>${nbHits} ${__('results displayed', 'vn')}</p>
      `
    })

    const jsCloseAlgoliaFilters = document.querySelector('.js-close-algolia-filters span');

    jsCloseAlgoliaFilters.querySelector('b') ? jsCloseAlgoliaFilters.querySelector('b').remove() : '';
    jsCloseAlgoliaFilters.innerHTML += ' <b>('+ nbHits +')</b>';
  }

  const renderCurrentRefinements = ({ items, widgetParams }) => {
    const container = document.querySelector(widgetParams.container)
    const totalItemCount = items.reduce(
      (acc, curr) => acc + curr.refinements.length,
      0
    )

    container.innerHTML = sprintf(
      _n('%s active filter', '%s active filters', totalItemCount, 'vn'),
      totalItemCount
    )
  }

  const customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  )

  const customStats = connectStats(renderStats)

  productsSearch.addWidgets([
    customSearchBox({
      container: '.pt-products__search-handler',
      placeholder: __('Search a product', 'vn'),
      showLoadingIndicator: false,
    }),

    clearRefinements({
      container: '.pt-products__extra--reset-handler',
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html` <div class="vn-btn vn-btn--link">
            ${hasRefinements
              ? __('Reset filters', 'vn')
              : __('No filters', 'vn')}
          </div>`
        },
      },
    }),

    configure({
      index: 'product_price_asc',
    }),

    sortBy({
      container: window.innerWidth > 768 ? '.pt-products__product-sortby-handler' : '.pt-products__product-sortby-handler-mobile',
      cssClasses: {
        root: 'vn-input vn-select js-sortby',
      },
      items: [
        { label: __('Price (asc)', 'vn'), value: 'product_price_asc' },
        { label: __('Price (desc)', 'vn'), value: 'product_price_desc' },
      ],
    }),

    hierarchicalMenu({
      container: '.pt-products__product-brands-handler',
      attributes: ['productCatHierarchical.lvl0', 'productCatHierarchical.lvl1'],
      limit: 999,
    }),

    refinementList({
      container: '.pt-products__product-attributes-handler',
      attribute: 'attributes',
      limit: 99,
      sortBy: ['name:asc'],
    }),

    customInfiniteHits({
      container: document.querySelector('.pt-products__hits'),
    }),

    customCurrentRefinements({
      container: '.pt-products__extra--stats-handler',
    }),

    configure({
      hitsPerPage: 21,
    }),
    customStats({}),
  ])

  productsSearch.start()
}

export { productsSearch }

$('.js-open-algolia-filters').on('click', function (e) {
  $('.js-algolia-filters').fadeIn()
  lockBody()
})

$('.js-close-algolia-filters').on('click', function (e) {
  $('.js-algolia-filters').fadeOut()
  unlockBody()
})

$('.js-back-to-filters').on('click', function (e) {
  e.preventDefault();
  document.getElementById('filtres').scrollIntoView({ behavior: 'smooth' });
})
